import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, ModalController, LoadingController } from 'ionic-angular';
import { TakeawayServices } from '../../services';
import { Globals } from '../../../../globals';
import { PrintServices } from '../../../services/printServices';
import { TakeawayOrderSelectPage } from '../../takeaway-order-select/takeaway-order-select';
import { TakeawayOrderUpDelPage } from '../../takeaway-order-updel/takeaway-order-updel';
import { TakeawayCreateSelectCustomerPage } from '../../takeaway-create/takeaway-create-select-customer/takeaway-create-select-customer';
import { TPVServices } from '../../../tpv/services';
import { TpvLoaderPage } from '../../../tpv/tpv-loader/tpv-loader';
import { TranslateService } from '@ngx-translate/core';
import { TipsPage } from '../../../components/popups/tips/tips';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { PopupSelectPayment } from '../../../components/popups/popup-select-payment/popup-select-payment';
import * as firebase from 'firebase';
import { PrintTicketOrETicket } from '../../../components/popups/print-ticket-or-eticket/print-ticket-or-eticket';
import { HttpClient, HttpParams } from '@angular/common/http';
import { getCurrencySymbol } from '@angular/common';
import * as moment from 'moment';
import { PopupSelectCustomer } from '../../../components/popups/popup-select-customer/popup-select-customer';





/**
 * Generated class for the TpvTicketPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-buttons',
  templateUrl: 'takeaway-order-buttons.html',
})
export class TakeawayOrderButtonsPage {
  public firestore;

  qr_link: string = '';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    public printServices: PrintServices,
    public tpvServices: TPVServices,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public translate: TranslateService,
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    public analyticsServices: AnalyticsServices,
    public http: HttpClient,
  ) {
    this.firestore = firebase.firestore();

  }

  /**********************************************************/
  /*                        FUNCIONES                       */
  /**********************************************************/

  async printKitchen() {

    this.globals.GAtrackView('TakeAway', 'TakeAway - Kitchen - Print', this.globals.restaurant.email, 'View', 'Print kitchen', 'TakeAway', '');

    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //getOrdersAllPrint
    await this.takeawayServices.getOrdersAllPrint(this.globals.restaurant_uid, this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID);


    if (this.globals.restaurant.printer_type == 'native') {
      this.globals.print_content = document.getElementById('print_takeaway');
      this.takeawayServices.print_type = true;

      this.takeawayServices.orders_print = 'all';
      var interval = setInterval(() => {
        this.printServices.printNow('print_takeaway');
        clearInterval(interval);
      }, 1000);
    } else {
      this.printServices.prepareOrderKitchen('all', this.takeawayServices.listall_print, this.takeawayServices.listall_print, this.globals.restaurant.printer_type, 'tk');
    }
  }

  async cancelTicket() {
    const confirm = this.alertCtrl.create({
      title: this.translate.instant('tk-cancelar-pedido'),
      message: this.translate.instant('tk-cancelar-pedido-des'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          handler: () => {

          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.globals.GAtrackView('TakeAway', 'TakeAway - Delete', this.globals.restaurant.email, 'Delete', 'Delete takeaway', 'TakeAway', '');
            //data set waiter activity
            var extra_activity: any =
            {
              'type': 'cancel',
              'value': 1,
              'source': 'takeaway',

            };
            this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
            this.deleteTicket();
          }
        }
      ]
    });
    confirm.present();
  }

  async deleteTicket() {
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //
    var tk_tmp = this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index];
    //delete orders (variable)
    await this.takeawayServices.deleteOders(this.globals.restaurant_uid, this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID);
    //delete true tpvtable
    this.deleteFromTables();
    //insert _data analytics WAITER
    let _element = [];
    _element.push("TICKET")
    var waiter = {
      'uid': this.globals.restaurant_uid,
      'waiter': this.globals.waiter,
      'elements': _element,
      'date': new Date(),
      'type': "waiter",
      'type_type': "DELETE",
    };
    this.analyticsServices.sendWaiter(waiter);
    //insert _data analytics cancel_tickets
    if (tk_tmp.ticket.number && !tk_tmp.ticket.payment) {
      var cancel_table_ticket = {
        'uid': this.globals.restaurant_uid,
        'number': tk_tmp.ticket.number,//numero ticket cancelado
        'cash': tk_tmp.cash_static,//caja que dio el numero ticket
        'cash_uid': tk_tmp.cash_uid,//uid de la caja
        'type': 'takeaway',//table o tk (sitio donde se ejecuto)
        'amount': this.takeawayServices.totalTicketSelected(this.takeawayServices.selected_table_tpv_index),//total mesa
        'name': tk_tmp.UID.substr(tk_tmp.UID.length - 4).toUpperCase(),// nombre mesa/tk
        'waiter': this.globals.waiter,//camrero que ejecuto accion
        'app_section': 'APP2',//app donde se ejecuto
        'date': new Date()
      }
      this.analyticsServices.cancelTableTicket(cancel_table_ticket);
    }
  }




  async printOrETicket(customer = "") {
    try {

      if (customer == "") {
        customer = this.takeawayServices.customer;
      }
      //Comprovamos si el ticket digital esta activado
      if (this.globals.restaurant.tickets.ticket_digital || this.globals.restaurant.tickets.ticket_digital == undefined) {
        let profileModal = this.modalCtrl.create(PrintTicketOrETicket,
          {
            title: this.translate.instant('general-ticket'),
            customer: customer,
            table: 'tk',

          });
        profileModal.onDidDismiss(async data => {
          if (data != undefined) {
            if (data == "printTicket") {
              this.printTicket();
            } else if (data == "eTicket") {
              if (this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].customer_email != undefined && this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].customer_email != "") {

                let url_mctpay = "";
                if (!this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.payment) {
                  url_mctpay = await this.createMctPayCharge();
                }

                //crear numero de ticket
                await this.takeawayServices.getTicketNumber(this.globals.restaurant_uid, this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].cash_uid)

                //enviar ticket digital
                this.eTicket(
                  this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket, //ticket
                  this.takeawayServices.customer, //customer
                  url_mctpay, //link
                  this.takeawayServices.totalTicketSelectedNoTax(this.takeawayServices.selected_table_tpv_index, this.globals.RESTAURANT_TAX), //subtotal
                  "takeaway"); //tipo
              }
              //notificamos al usuario de que el ticket se envio
              let toast = this.toastCtrl.create({
                message: this.translate.instant('eticket-ticket-digital-enviado-correctamente'),
                duration: 3000,
                position: 'bottom'
              });
              toast.present();

            } else if (data == "editCustomer") {

              let profileModalPopup = await this.modalCtrl.create(PopupSelectCustomer,
                {
                  title: this.translate.instant('general-selecciona-cliente'),
                });
              profileModalPopup.onDidDismiss(async data => {
                if (data != undefined) {
                  this.printOrETicket(data);

                } else {
                  this.printOrETicket();
                }

              });

              profileModalPopup.present();
            }

          } else {

          }
        });

        profileModal.present();
      } else {
        this.printTicket();
      }
    } catch (error) {
      //notificamos al usuario de que el ticket no se puedo enviar correctamente
      let toast = this.toastCtrl.create({
        message: this.translate.instant('eticket-error-al-enviar-ticket-digital'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  async createMctPayCharge() {
    //Recuperamos la url del mct_pay_web, para el qr
    try {
      const params = new HttpParams()
        .set('public_key', this.globals.public_key)
        .set('table_uid', this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID);

      const url_mctpay = await this.http.post(this.globals.analytics_path + 'mctwebpay/create_mct_pay_charge', params, {}).toPromise()
      return url_mctpay['url_mct_pay_charge'];
    } catch (error) {
      return "";
    }

  }

  eTicket(ticket, customer, mct_pay_charge, subtotal, type) {
    //tener en cuenta que el email y otros datos si viene de deliverecto no son el customer_name y etc

    var _date = '';
    if (ticket.date.seconds) {
      _date = moment(new Date(this.globals.timestampToDate(ticket.date))).format('YYYY/MM/DD HH:mm');
    } else {
      _date = moment(ticket.date).format('YYYY/MM/DD HH:mm');
    }

    this.cleanTicketArray(ticket.list);

    let _email = {
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'type': 'eticket_mctpay',
      'customer_name': this.globals.ifVarEmpty(customer.name),
      'customer_email': this.globals.ifVarEmpty(customer.email),
      'customer_phone': this.globals.ifVarEmpty(customer.phone),
      'takeaway_type': type,
      'ticket_number': ticket.number,
      'ticket_list': ticket.list,
      'ticket_date': _date,
      'ticket_currency': getCurrencySymbol(this.globals.user_currency, 'narrow', 'es'),
      'ticket_subtotal': subtotal,
      'ticket_total': this.takeawayServices.totalTicketSelected(this.takeawayServices.selected_table_tpv_index),
      'ticket_tax_name': this.globals.user_tax_name,
      'ticket_tax': this.globals.RESTAURANT_TAX,
      'restaurant_company': this.globals.restaurant.company,
      'restaurant_address': this.globals.restaurant.address,
      'restaurant_email': this.globals.restaurant.email,
      'restaurant_phone': this.globals.restaurant.phone,
      'restaurant_logo': this.getImageUrl(this.globals.restaurant.logo), //this.restaurant.logo
      'order_status': "",
      'mct_pay_charge': mct_pay_charge
    }
    this.firestore.collection('_emails').add(_email);
  }

  //Limpiamos array para subir a firebase
  cleanTicketArray(ticket_list) {
    for (let key in ticket_list) {
      delete ticket_list[key].variation_array;
      delete ticket_list[key].variation_add;
    }
  }

  getImageUrl(img_url) {
    if (img_url != '' && img_url != undefined) {
      img_url = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/' + img_url.replace('logo/', 'logo%2F') + '?alt=media';
      return img_url;
    } else {
      return '';
    }

  }

  async printTicket() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-imprimiendo')
    });
    loadingPopup.present();

    this.globals.GAtrackView('TakeAway', 'TakeAway - Ticket - Print', this.globals.restaurant.email, 'View', 'Print ticket', 'TakeAway', '');
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //get ticket number
    await this.takeawayServices.getTicketNumber(this.globals.restaurant_uid, this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].cash_uid)
    //volver a buscar los elementos para que tengan variations i variation_add que los limpia la funcion anterior
    this.takeawayServices.selected_list = this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list));
    //marcamos a false para que imprima el ticket y no la orden
    this.takeawayServices.print_type = false;
    //caso native
    if (this.globals.restaurant.printer_type == 'native') {
      this.takeawayServices.orders_print = 'all';
      //getIndexByTableuid
      await this.takeawayServices.getIndexByTableuid();
      //
      await this.takeawayServices.getOrdersAllPrint(this.globals.restaurant_uid, this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID);
      //
      this.globals.print_content = document.getElementById('print_takeaway_ticket_normal');
      //
      var interval = setInterval(() => {
        this.printServices.printNow('print_takeaway_ticket_normal');
        clearInterval(interval);
      }, 1000);
    } else {//caso services
      //getIndexByTableuid
      await this.takeawayServices.getIndexByTableuid();
      //send to print
      this.printServices.prepareTicket(this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list))[0]
        , new Date()
        , this.takeawayServices.totalTicketSelectedNoTax(this.takeawayServices.selected_table_tpv_index, this.globals.RESTAURANT_TAX)
        , this.takeawayServices.totalTicketSelected(this.takeawayServices.selected_table_tpv_index)
        , this.tpvServices.calculateIva(this.takeawayServices.totalTicketSelected(this.takeawayServices.selected_table_tpv_index), this.takeawayServices.totalTicketSelectedNoTax(this.takeawayServices.selected_table_tpv_index, this.globals.RESTAURANT_TAX), this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket)
        , this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.waiter
        , this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].room
        , this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].name
        , this.globals.restaurant.tickets.footer
        , 'tk'
        , this.takeawayServices.ticket_num_return
        , this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket
        , this.globals.restaurant.printer_type
        , false
        , this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.customer_comment || '');
    }
    loadingPopup.dismiss();
  }

  openPayed() {
    let toast = this.toastCtrl.create({
      message: this.translate.instant('instant-pedido-esta-cobrado'),
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  /**********************************************************/
  /*                         NAVCTRL                        */
  /**********************************************************/

  openSelect() {
    this.takeawayServices.update_state = false;
    this.navCtrl.push(TakeawayOrderSelectPage);
  }

  openMod() {
    this.navCtrl.push(TakeawayOrderUpDelPage, {
      update: true
    });
  }

  openDelete() {
    this.navCtrl.push(TakeawayOrderUpDelPage, {
      update: false
    });
  }

  async deleteFromTables() {
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //delete table
    this.takeawayServices.afs.doc('tables/' + this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID).delete();
    //tornar a pantalla takeaway
    this.tpvServices.menu_select_room = 'take_away';
    this.navCtrl.setRoot(TpvLoaderPage);
  }

  async openModCustomer() {
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //
    this.navCtrl.push(TakeawayCreateSelectCustomerPage, {
      update_state: true,
      uid_table: this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID,
    });
  }

  openPay() {
    //this.navCtrl.push(TakeawayOrderPayPage);
    let profileModal = this.modalCtrl.create(PopupSelectPayment,
      {
        table: this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index],
        origin: 'tk'

      });
    profileModal.onDidDismiss(data => {

    });
    profileModal.present();
  }

  openTip() {
    let profileModal = this.modalCtrl.create(TipsPage, { origin: 'tk' });
    profileModal.present();
  }



}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order/takeaway-order-buttons/takeaway-order-buttons.ts